import PropTypes from 'prop-types';
import { Box, Stepper, Step, StepLabel } from '@mui/material';

/**
 * StepIndicator - Progress stepper for multi-step wizards
 * 
 * Displays current progress in a multi-step form (e.g., registration wizard)
 * using Material-UI Stepper component with alternative label layout.
 */
const StepIndicator = ({ currentStep, steps }) => {
  return (
    <Box className="w-full mb-6">
      <Stepper activeStep={currentStep - 1} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

StepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default StepIndicator;

